// src/services/api.js
import axios from 'axios'

const baseURL = import.meta.env.VITE_API_BASE ?? '/api'   // 👈 base relativa

const api = axios.create({
  baseURL,
  withCredentials: false,
  timeout: 15000,
})

// Token en cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  r => r,
  err => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('token')
    }
    return Promise.reject(err)
  }
)

export default api
